module.exports = __webpack_public_path__ + "img/icon-liked.3f6630f3.svg";